<div class="manageUsers apiContainer" [class.inNewUI]="onNewUI" *transloco="let translate">
    <div class="usersMainDiv">
        <mat-drawer-container class="drawerContainer" autosize>
            <mat-drawer #drawer class="userMatDrawer w-100" mode="side" disableClose position="end">
                <app-integrations-template [subTenants]="R.subTenants" [masterTables]="R.masterTables" [title]="title" [record]="record" [config]="config" [sources]="sources" [openWidget]="drawer?.opened" [drawer]="drawer" [dontFetchUsingMasters]="true" [inConnectorsUI]="true" [translated]="true" (appChanged)="appChanged($event)" (gotoIntegrationsPage)="closeEdit()"></app-integrations-template>
                <div class="text-right pt-4 pr-5" [hidden]="!drawer?.opened">
                    <material-button class="!m-0 !mx-3" [classList]="['!w-auto']" [text]="translate('Cancel')" (buttonClicked)="closeEdit()"></material-button>
                    <material-button class="m-0 !mx-3" [classList]="['!w-auto']" [text]="record?.originalData?.resourceName?.length > 0 ? translate('Update') : translate('Save')" color="primary" (buttonClicked)="submitConfiguration()"></material-button>
                </div>
            </mat-drawer>
            <mat-drawer-content>
                <div class="userTableMainDiv" *transloco="let translate">
                    <div class="userTableContainer userMainTableConatiner">
                        <div class="flex items-center justify-between border-b border-[#ccc] h-[47.5px] px-[16px] font-bold">
                            <span class="text-[15px] font-bold whitespace-nowrap overflow-hidden text-ellipsis max-w-[25%]" [textContent]="translate('Connectors')"></span>
                            <div class="flex-1 flex justify-center items-center">
                                <div class="outlookSearchContainer">
                                    <div class="outLookSearchHolder">
                                        <div class="items-center d-flex mainSearch">
                                            <div class="mainSearchSearcher !min-w-[800px] searchBorder cursor-pointer d-flex align-items-center justify-between">
                                                <span class="material-icons searchIcon">search</span>
                                                <input matInput type="text" [debounce]="500" (eventHandler)="searchSystems()" [placeholder]="translate('Search')" [(ngModel)]="searchText" />
                                                <span class="material-icons searchIcon pointer" *ngIf="searchText" (click)="clearSearch()">close</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span *ngIf="isProviderOrganization" class="p-2 cursorPointer whitespace-nowrap font-bold" [title]="translate('Create New')" [routerLink]="'new'" [textContent]="translate('Create New')"></span>
                        </div>
                        <div class="row w-100 m-0">
                            <div class="col-12 ps position-relative h-[calc(100vh-133px)]" [perfectScrollbar]>
                                <div class="userTable noMargin">
                                    <div class="grid grid-cols-3 gap-3">
                                        <ng-container *ngIf="connectors | FilterPipe : 'connectorDisplayName' : searchText : undefined : 'connectorName' as connectorResults">
                                            <ng-container *ngFor="let connector of connectorResults">
                                                <div class="p-3 h-full">
                                                    <ng-container *ngTemplateOutlet="connectorTemplate; context: { connector }"></ng-container>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-drawer-content>
        </mat-drawer-container>
    </div>
</div>

<ng-template #connectorTemplate let-connector="connector">
    <div class="p-2 h-[36px] pl-4 bg-[#d1f5d3] w-[75%] rounded-t-lg border-[1px] border-[#d1f5d3]">
        <span class="text-gray-800 text-[13px] font-bold overflow-hidden text-ellipsis whitespace-nowrap" [matTooltip]="connector?.connectorDisplayName" [textContent]="connector?.connectorDisplayName"></span>
    </div>
    <div class="border border-gray-200 p-4 h-[calc(100%-36px)]">
        <div class="" *transloco="let translate">
            <div class="flex mb-2">
                <div class="w-[4em] h-[4em] mr-2">
                    <span class="material-symbols-outlined w-full h-full !text-[4em] opacity-50 text-[#134065]">image</span>
                </div>
                <div class="w-[calc(100%-2-4em)] font-medium leading-[4em] overflow-hidden text-ellipsis whitespace-nowrap" [matTooltip]="connector?.connectorName" [textContent]="connector?.connectorName"></div>
            </div>
            <div>
                <div class="text-sm text-gray-600 mb-1 overflow-hidden text-ellipsis whitespace-nowrap" [matTooltip]="connector?.description">
                    <span class="font-bold" [textContent]="translate('Description') + ':'"></span>
                    <span [textContent]="connector?.description"></span>
                </div>
                <div class="text-sm text-gray-600 mb-1 overflow-hidden text-ellipsis whitespace-nowrap" [matTooltip]="connector?.sourceSystem">
                    <span class="font-bold" [textContent]="translate('Source System') + ':'"></span>
                    <span [textContent]="connector?.sourceSystem"></span>
                </div>
                <div class="text-right">
                    <material-button class="!m-0 !mx-3" [classList]="['!w-auto']" [text]="translate('Edit')" [color]="'primary'" [buttonPurpose]="'ROUTER_LINK'" [routerLink]="connector?.connectorName"></material-button>
                    <span class="inline-block">
                        <material-button class="!m-0 !mx-3" [prefixIcon]="'delete'" [color]="'default'" (buttonClicked)="deleteConnector(connector)"></material-button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<router-outlet></router-outlet>
